import { injectCoverVideoEmbed } from "../utils/video-embeds.js";

/**
 * Home hero: one background layer for `.hero-shared-bg` — MP4, YouTube, or Vimeo
 * (data attributes on `.hero-shared-bg__video-wrap`).
 */
export function heroSharedVideo() {
  const wrap = document.querySelector(".hero-shared-bg__video-wrap");
  if (!wrap) {
    return;
  }

  const videoType = (wrap.getAttribute("data-video-type") || "mp4").toLowerCase();
  const videoSrc = wrap.getAttribute("data-video-src") || "";
  const videoId = (wrap.getAttribute("data-video-id") || "").trim();

  injectCoverVideoEmbed(wrap, videoType, { src: videoSrc, id: videoId }, "hero-shared-bg__video").then(
    (el) => {
      if (!el) {
        return;
      }
      el.setAttribute("aria-hidden", "true");
      if (el.tagName === "VIDEO") {
        el.setAttribute("preload", "metadata");
      }
    }
  );
}
